export default {
  errorNotAnImage: 'Podgląd niemożliwy, plik nie jest obrazem lub nie jest już dostępny.',
};
